// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"dadc5ba1","404":"c344c7c9","498":"b24a1338","787":"1cd31a9e"}[chunkId] + ".chunk.js";
};